import { AnswerSelectContainerProps } from '../config';
import { CountryKey } from '../../../../utils/wpo/codes';
import { FC, useEffect } from 'react';
import { IAnswerModel } from '../../../../state/stores/Question/AnswerModel';
import { SnapshotOrInstance } from 'mobx-state-tree';
import { countryFlags } from '../../../../utils/wpo/flags';
import { observer } from 'mobx-react';
import { useInitChoiceWithFirstAnswer } from '../useInitChoiceWithFirstAnswer';
import { useStores } from '../../../../hooks/useStores';

export const flagAndName = (country: CountryKey, labels: Record<string, string>) => {
  return countryFlags?.[country] + '   ' + labels?.[country?.toUpperCase()];
};

export const answerRegions = (countries: string[], labels: Record<string, string>) : IAnswerModel[] => {
  return countries.map((country: string): IAnswerModel => {
    return {
      nextKey: null,
      _id: country,
      key: country,
      wording: flagAndName(country as CountryKey, labels),
      featureChoice: null,
      specialTypeOfAnswer: true
    } as IAnswerModel;
  });
};

const _ContainRegionInstantHelp: FC<AnswerSelectContainerProps> = ({
  question,
  onPress,
  children,
}) => {
  const { user, language } = useStores();
  const labels = language?.translate.MOBILE?.ASSISTANCE?.INSTANT_HELP;
  const answers = answerRegions(user?.regions, labels?.REGIONS);

  const [initAnswer] = useInitChoiceWithFirstAnswer({
    answers,
    questionId: question._id,
    questionKey: question.key,
  });

  // automatically initialised answer also sets user region
  useEffect(() => {
    if (initAnswer?._id) {
      console.log(`ContainRegionInstantHelp.useEffect user.setRegion(${initAnswer._id})`);
      user.setRegion(initAnswer._id as CountryKey);
    }
  }, [initAnswer?._id, user]);

  const onPressIdiosyncratic = (answer: SnapshotOrInstance<IAnswerModel>) => {
    if(answer!.specialTypeOfAnswer) {
      console.log(`ContainRegionInstantHelp.onPressIdiosyncratic user.setRegion(${answer._id})`);
      user.setRegion(answer._id as CountryKey);
    }
    onPress(answer);
  };

  return children({
    answers: answers,
    initSelected: initAnswer,
    questionId: question._id,
    questionKey: question.key,
    onPress: onPressIdiosyncratic,
    labels: {
      DROPDOWN: labels?.REGION
    },
  });

};

export const ContainRegionInstantHelp = observer(_ContainRegionInstantHelp);

